import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";

import "./contact.css"

const Contact = () =>  {

  function onChange(value) {
    console.log("Captcha value:", value);
  }

    return (
      <section className="contactUsPage">
        <div className="container px-0">
        <div className="row mx-0 jc-center"> 
          <div className="w-100" style={{maxWidth:"650px"}}>
            <form >
                <div className="card  contactDiv rounded-0">
              {/* <div className="card-header p-0 pt-2">
                <div className=" headerColor  text-center py-2">
                  <h3 className="bold-font h4  themeColor2 text-center"><i className="fa fa-envelope" /> Contact Us</h3>
                </div>
              </div> */}
              <div className="card-body p-3">
                {/*Body*/}
                <div className="form-group">
                  <span className='bold-semifont para'>Name</span>
                    <input className="form-control" type="text" placeholder="Name..." name="name" ></input>
                </div>
                <div className="form-group">
                  <span className='bold-semifont para'>Email</span>
                    <input className="form-control" type="email" placeholder="example@gmail.com" name="email" ></input>
                </div>
                <div className="form-group">
                  <span className='bold-semifont para'>Message </span>
                    <input className="form-control" type="text" placeholder="Message..." name="message" ></input>
                </div>

                <ReCAPTCHA
                    sitekey="6LdUCo8cAAAAAMMNEEh3GOOlfSDIBGA261hWxAPr"
                    render="explicit"
                    onChange={onChange}
                  />
                <div className="text-center">
                  <input type="submit" defaultValue="Enviar" className="round-button mt-3" />
                </div>
              </div>
            </div>
            </form>
            {/*Form with header*/}
          </div>
            {/* <div className="col-lg-5 col-md-6">
              <div className="card rounded-0 contactAdressCard">
                <div className="card-header p-0 pt-2">
                  <div className=" headerColor bg-info text-white text-center py-2">
                    <h3 className="bold-font h4 themeColor2 text-center"><i className="fa fa-home" /> Address</h3>
                  </div>
                </div>
                <div className="addressDiv">
                  <div className="d-flex"><span><i class="fa fa-map-marker" aria-hidden="true"></i></span><p> 13 Riverplace Cres Brampton</p></div>
                  <div className="d-flex"><span><i class="fa fa-thumb-tack" aria-hidden="true"></i></span><p> Brampton</p></div>
                  <div className="d-flex"><span><i class="fa fa-globe" aria-hidden="true"></i></span><p> Canada</p></div>
                  <div className="d-flex"><span><i class="fa fa-envelope" aria-hidden="true"></i></span> <p>example@gmail.com</p></div>
                  <div className="d-flex"><span><i class="fa fa-phone" aria-hidden="true"></i></span><p> 9212345678</p></div>
                </div>
                
              </div>
     
            </div> */}
        </div>
      </div>
      </section>
    )
  }

export default Contact;